import React from 'react';
import { useNavigate } from 'react-router-dom';
import PixelBlast from '../../components/PixelBlast';
import ShineButton from '../../components/ShineButton';
import './css/CTASection.css';

const CTASection = () => {
    const navigate = useNavigate();

    const handleGetStarted = () => {
        navigate('/contact-us');
    };

    return (
        <section className="cta-section">
            <div className="cta-container">
                <div className="cta-background">
                    <PixelBlast
                        variant="square"
                        pixelSize={4}
                        patternScale={2}
                        patternDensity={1}
                        pixelSizeJitter={0}
                        speed={0.5}
                        edgeFade={0.25}
                        enableRipples={true}
                        liquid={false}
                        color="#B19EEF" // Purple color from the config
                        transparent={true}
                    />
                </div>

                <div className="cta-content">
                    <h2 className="cta-title">Start Advertising on Ravooka</h2>
                    <p className="cta-subtext">
                        Launch your campaign across premium digital news publishers in minutes.
                    </p>
                    <div className="cta-button-wrapper">
                        <ShineButton
                            text="Get Started"
                            className="shine-btn--white cta-shine-btn"
                            onClick={handleGetStarted}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
